import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import GlobalHreflang from './components/GlobalHreflang';

// Danish Pages (Master version - strictly unmodified)
import HomePage from './pages/HomePage';
import ProductsLandingPage from './pages/ProductsLandingPage';
import ProductDetailPage from './pages/ProductDetailPage';
import SingleProductPage from './pages/SingleProductPage';
import UsedPressesPage from './pages/UsedPressesPage';
import AboutPage from './pages/AboutPage';
import SuppliersPage from './pages/SuppliersPage';
import PartnersPage from './pages/PartnersPage';
import JobsPage from './pages/JobsPage';
import ContactPage from './pages/ContactPage';
import TermsPage from './pages/TermsPage';
import ServicePage from './pages/ServicePage';
import SparePartsPage from './pages/SparePartsPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

// English Pages (Localized version)
import HomePageEn from './pages/en/HomePageEn';
import AboutPageEn from './pages/en/AboutPageEn';
import ContactPageEn from './pages/en/ContactPageEn';
import ServicePageEn from './pages/en/ServicePageEn';
import SparePartsPageEn from './pages/en/SparePartsPageEn';
import UsedPressesPageEn from './pages/en/UsedPressesPageEn';
import SuppliersPageEn from './pages/en/SuppliersPageEn';
import PartnersPageEn from './pages/en/PartnersPageEn';
import JobsPageEn from './pages/en/JobsPageEn';
import TermsPageEn from './pages/en/TermsPageEn';
import ProductDetailPageEn from './pages/en/ProductDetailPageEn';
import SingleProductPageEn from './pages/en/SingleProductPageEn';
import NotFoundPageEn from './pages/en/NotFoundPageEn';

export default function App() {
  return (
    <HelmetProvider>
      <div className="min-h-screen flex flex-col bg-white text-stone-900 font-sans selection:bg-[#006368] selection:text-white">
        <ScrollToTop />
        <GlobalHreflang />
        <Header />

        <main className="flex-1">
          <Routes>
            {/* =========================================
                DANISH MASTER VERSION (Original Routes)
               ========================================= */}
            <Route path="/" element={<HomePage />} />

            {/* Produkter & Ydelser */}
            <Route path="/produkter" element={<ProductsLandingPage />} />
            <Route path="/produkt/:slug" element={<SingleProductPage />} />
            <Route path="/produkter/:slug" element={<SingleProductPage />} />
            <Route
              path="/centralsmoering"
              element={<ProductDetailPage specificSlug="centralsmoering" />}
            />
            {/* 1. Coilanlæg og følgeudstyr */}
            <Route
              path="/coilanlaeg"
              element={<ProductDetailPage specificSlug="coilanlaeg" />}
            />
            <Route
              path="/coilanlaeg-og-foelgeudstyr"
              element={<ProductDetailPage specificSlug="coilanlaeg" />}
            />
            <Route
              path="/rettevaerk"
              element={<ProductDetailPage specificSlug="coilanlaeg" />}
            />
            <Route
              path="/udstyr"
              element={<ProductDetailPage specificSlug="coilanlaeg" />}
            />

            {/* 2. Laser (Underkategorier: Fiberlaser & Rørlaser) */}
            <Route
              path="/laser"
              element={<ProductDetailPage specificSlug="fiberlaser" />}
            />
            <Route
              path="/fiberlaser"
              element={<ProductDetailPage specificSlug="fiberlaser" />}
            />
            <Route
              path="/roerlaser"
              element={<ProductDetailPage specificSlug="roerlaser" />}
            />

            {/* 3. Slibe- og afgratemaskiner */}
            <Route
              path="/slibe-og-afgratemaskiner"
              element={<ProductDetailPage specificSlug="slibe-og-afgratemaskiner" />}
            />
            <Route
              path="/slibemaskiner"
              element={<ProductDetailPage specificSlug="slibe-og-afgratemaskiner" />}
            />

            {/* 4. Pladeklipning */}
            <Route
              path="/pladeklipning"
              element={<ProductDetailPage specificSlug="pladeklipning" />}
            />
            <Route
              path="/saks"
              element={<ProductDetailPage specificSlug="pladeklipning" />}
            />

            {/* 5. Panelbukker */}
            <Route
              path="/panelbukker"
              element={<ProductDetailPage specificSlug="panelbukker" />}
            />

            {/* 6. Presse (Underkategorier: Hydraulisk presse, Kantpresse, Mekanisk presse) */}
            <Route
              path="/presser"
              element={<ProductDetailPage specificSlug="presser" />}
            />
            <Route
              path="/hydraulisk-presse"
              element={<ProductDetailPage specificSlug="hydraulisk-presse" />}
            />
            <Route
              path="/kantpresse"
              element={<ProductDetailPage specificSlug="kantpresser" />}
            />
            <Route
              path="/kantpresser"
              element={<ProductDetailPage specificSlug="kantpresser" />}
            />
            <Route
              path="/kantbukker"
              element={<ProductDetailPage specificSlug="kantpresser" />}
            />
            <Route
              path="/mekanisk-presse"
              element={<ProductDetailPage specificSlug="mekanisk-presse" />}
            />

            {/* 7. Styringer og software */}
            <Route
              path="/styringer-og-software"
              element={<ProductDetailPage specificSlug="styringer-og-software" />}
            />

            {/* Reservedele & Service */}
            <Route path="/reservedele" element={<SparePartsPage />} />
            <Route path="/service" element={<ServicePage />} />

            {/* Brugte maskiner */}
            <Route path="/presser-2" element={<UsedPressesPage />} />
            <Route path="/brugte-maskiner" element={<UsedPressesPage />} />

            {/* Om os & Virksomheden */}
            <Route path="/om-os" element={<AboutPage />} />
            <Route path="/leverandoerer" element={<SuppliersPage />} />
            <Route path="/pmb-partnere" element={<PartnersPage />} />
            <Route path="/samarbejdspartnere" element={<PartnersPage />} />
            <Route path="/pmb-job-ledige-stillinger" element={<JobsPage />} />

            {/* Kontakt & Betingelser */}
            <Route path="/kontakt" element={<ContactPage />} />
            <Route
              path="/pmb-salgs-leveringsbetingelser"
              element={<TermsPage />}
            />

            {/* =========================================
                ENGLISH LOCALIZED VERSION (/en/...)
               ========================================= */}
            <Route path="/en" element={<HomePageEn />} />

            {/* English Products & Machinery */}
            <Route path="/en/products" element={<ProductsLandingPage />} />
            <Route path="/en/product/:slug" element={<SingleProductPageEn />} />
            <Route path="/en/products/:slug" element={<SingleProductPageEn />} />
            <Route
              path="/en/central-lubrication"
              element={<ProductDetailPageEn specificSlug="central-lubrication" />}
            />
            <Route
              path="/en/centralsmoering"
              element={<ProductDetailPageEn specificSlug="central-lubrication" />}
            />

            {/* English 1. Coil lines */}
            <Route
              path="/en/coilanlaeg"
              element={<ProductDetailPageEn specificSlug="coilanlaeg" />}
            />
            <Route
              path="/en/coilanlaeg-og-foelgeudstyr"
              element={<ProductDetailPageEn specificSlug="coilanlaeg" />}
            />
            <Route
              path="/en/equipment"
              element={<ProductDetailPageEn specificSlug="equipment" />}
            />
            <Route
              path="/en/udstyr"
              element={<ProductDetailPageEn specificSlug="equipment" />}
            />

            {/* English 2. Laser (Fiber & Tube) */}
            <Route
              path="/en/laser"
              element={<ProductDetailPageEn specificSlug="fiberlaser" />}
            />
            <Route
              path="/en/fiberlaser"
              element={<ProductDetailPageEn specificSlug="fiberlaser" />}
            />
            <Route
              path="/en/roerlaser"
              element={<ProductDetailPageEn specificSlug="roerlaser" />}
            />

            {/* English 3. Grinding */}
            <Route
              path="/en/slibe-og-afgratemaskiner"
              element={<ProductDetailPageEn specificSlug="slibe-og-afgratemaskiner" />}
            />
            <Route
              path="/en/slibemaskiner"
              element={<ProductDetailPageEn specificSlug="slibe-og-afgratemaskiner" />}
            />
            <Route
              path="/en/grinding-machines"
              element={<ProductDetailPageEn specificSlug="slibe-og-afgratemaskiner" />}
            />

            {/* English 4. Shearing & Cutting */}
            <Route
              path="/en/pladeklipning"
              element={<ProductDetailPageEn specificSlug="shears" />}
            />
            <Route
              path="/en/shears"
              element={<ProductDetailPageEn specificSlug="shears" />}
            />
            <Route
              path="/en/saks"
              element={<ProductDetailPageEn specificSlug="shears" />}
            />

            {/* English 5. Panel Benders */}
            <Route
              path="/en/panelbukker"
              element={<ProductDetailPageEn specificSlug="panelbukker" />}
            />
            <Route
              path="/en/panel-benders"
              element={<ProductDetailPageEn specificSlug="panelbukker" />}
            />

            {/* English 6. Presses */}
            <Route
              path="/en/presses"
              element={<ProductDetailPageEn specificSlug="presses" />}
            />
            <Route
              path="/en/presser"
              element={<ProductDetailPageEn specificSlug="presses" />}
            />
            <Route
              path="/en/hydraulisk-presse"
              element={<ProductDetailPageEn specificSlug="hydraulisk-presse" />}
            />
            <Route
              path="/en/hydraulic-presses"
              element={<ProductDetailPageEn specificSlug="hydraulisk-presse" />}
            />
            <Route
              path="/en/kantpresse"
              element={<ProductDetailPageEn specificSlug="press-brakes" />}
            />
            <Route
              path="/en/press-brakes"
              element={<ProductDetailPageEn specificSlug="press-brakes" />}
            />
            <Route
              path="/en/kantpresser"
              element={<ProductDetailPageEn specificSlug="press-brakes" />}
            />
            <Route
              path="/en/mekanisk-presse"
              element={<ProductDetailPageEn specificSlug="mekanisk-presse" />}
            />
            <Route
              path="/en/mechanical-presses"
              element={<ProductDetailPageEn specificSlug="mekanisk-presse" />}
            />

            {/* English 7. Controls & Software */}
            <Route
              path="/en/styringer-og-software"
              element={<ProductDetailPageEn specificSlug="styringer-og-software" />}
            />
            <Route
              path="/en/controls-and-software"
              element={<ProductDetailPageEn specificSlug="styringer-og-software" />}
            />

            {/* Spare Parts & Service */}
            <Route path="/en/spare-parts" element={<SparePartsPageEn />} />
            <Route path="/en/reservedele" element={<SparePartsPageEn />} />
            <Route path="/en/service" element={<ServicePageEn />} />

            {/* Used Presses */}
            <Route path="/en/used-presses" element={<UsedPressesPageEn />} />
            <Route path="/en/used-machines" element={<UsedPressesPageEn />} />
            <Route path="/en/brugte-maskiner" element={<UsedPressesPageEn />} />
            <Route path="/en/presser-2" element={<UsedPressesPageEn />} />

            {/* About us & Company */}
            <Route path="/en/about" element={<AboutPageEn />} />
            <Route path="/en/om-os" element={<AboutPageEn />} />
            <Route path="/en/suppliers" element={<SuppliersPageEn />} />
            <Route path="/en/leverandoerer" element={<SuppliersPageEn />} />
            <Route path="/en/partners" element={<PartnersPageEn />} />
            <Route path="/en/pmb-partnere" element={<PartnersPageEn />} />
            <Route path="/en/jobs" element={<JobsPageEn />} />
            <Route path="/en/pmb-job-ledige-stillinger" element={<JobsPageEn />} />

            {/* Contact & Terms */}
            <Route path="/en/contact" element={<ContactPageEn />} />
            <Route path="/en/kontakt" element={<ContactPageEn />} />
            <Route
              path="/en/terms-and-conditions"
              element={<TermsPageEn />}
            />
            <Route
              path="/en/pmb-salgs-leveringsbetingelser"
              element={<TermsPageEn />}
            />

            {/* Status koder */}
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="/om-os-2" element={<NotFoundPage />} />
            <Route path="/en/om-os-2" element={<NotFoundPageEn />} />
            <Route path="/en/*" element={<NotFoundPageEn />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </HelmetProvider>
  );
}
